import { orderBy } from 'lodash';

export const sortBrandBriefs = (items) =>
  orderBy(items, ['updatedAt', 'name', 'id'], ['desc', 'asc', 'asc']);

export const BRAND_BRIEF_TYPE = {
  productDescription: 'product_description',
  companyDescription: 'company_description',
  oneLiner: 'one_liner',
  elevatorPitch: 'elevator_pitch',
  whoWeAre: 'who_we_are',
  other: 'other',
};

const BRAND_BRIEF_TYPE_PROPS = {
  [BRAND_BRIEF_TYPE.productDescription]: {
    label: 'Product Description',
  },
  [BRAND_BRIEF_TYPE.companyDescription]: {
    label: 'Company Description',
  },
  [BRAND_BRIEF_TYPE.oneLiner]: {
    label: '1-Liner',
  },
  [BRAND_BRIEF_TYPE.elevatorPitch]: {
    label: 'Elevator Pitch',
  },
  [BRAND_BRIEF_TYPE.whoWeAre]: {
    label: 'Who We Are',
  },
  [BRAND_BRIEF_TYPE.other]: {
    label: 'Other',
  },
};

export const getBrandBriefTypeLabel = (briefType) => BRAND_BRIEF_TYPE_PROPS[briefType]?.label;

export const brandBriefTypeHasTitle = (briefType) =>
  [BRAND_BRIEF_TYPE.productDescription, BRAND_BRIEF_TYPE.companyDescription].includes(briefType);
